const CORE_PRODUCT_DIMENSION_FILTER_KEYS = [
  'departments',
  'sub_departments',
  'manufacturers',
  'classes',
  'sub_classes',
  'brands',
  'seasons',
  'events',
  'collection_types',
] as const;

type CoreProductDimensionFilterKey =
  (typeof CORE_PRODUCT_DIMENSION_FILTER_KEYS)[number];

export const getRelevantCoreProductFilterKeys = (
  irrelevantKeys: CoreProductDimensionFilterKey[],
) => {
  const irrelevantKeysSet = new Set(irrelevantKeys);
  return CORE_PRODUCT_DIMENSION_FILTER_KEYS.filter(
    (key) => !irrelevantKeysSet.has(key),
  );
};
